// Kyte dictionary extractor. Two surfaces carry IATA → name data:
// orderData.dictionaries (canonical, richer names) on confirm/retrieve, and
// flightSolutions[].segments[] inline stubs on every body. Order matters:
// segment walks seed IATA stubs first, the canonical block folds in last so
// its richer airport names win where present.

import { get_object_field } from '@/utilities/commons';
import { fold_canonical_block, merge_location_entry } from '../base/helpers';

const KNOWN_DICT_PATHS = [
  'dictionaries',
  'data.dictionaries',
  'orderData.dictionaries',
  'data.orderData.dictionaries',
  'kyteVoucher.orderData.dictionaries',
  'data.kyteVoucher.orderData.dictionaries',
];

const KNOWN_FLIGHT_SOLUTIONS_PATHS = [
  'flightSolutions',
  'data.flightSolutions',
  'itinerary.flightSolutions',
  'booking.itinerary.flightSolutions',
  'orderData.booking.itinerary.flightSolutions',
  'data.orderData.booking.itinerary.flightSolutions',
  'kyteVoucher.orderData.booking.itinerary.flightSolutions',
  'data.kyteVoucher.orderData.booking.itinerary.flightSolutions',
];

const collect_segment_carrier = (acc, carrier) => {
  const { code = '', name = '' } = carrier || {};
  if (code && name) acc.carriers[code] = name;
};

const collect_segment_endpoint = (acc, endpoint) => {
  const { airport = {} } = endpoint || {};
  const { code = '', name = '', city = {} } = airport;
  if (!code) return;
  acc.locations[code] = merge_location_entry(
    { name, cityCode: city.code, cityName: city.name },
    acc.locations[code] || {}
  );
};

const fold_solutions_segments = (acc, flight_solutions) => {
  if (!flight_solutions || typeof flight_solutions !== 'object') return;
  Object.keys(flight_solutions).forEach((fs_id) => {
    const solution = flight_solutions[fs_id] || {};
    const segments = Array.isArray(solution.segments) ? solution.segments : [];
    segments.forEach((seg) => {
      collect_segment_carrier(acc, seg.marketingCarrier);
      collect_segment_carrier(acc, seg.operatingCarrier);
      collect_segment_endpoint(acc, seg.departure);
      collect_segment_endpoint(acc, seg.arrival);
    });
  });
};

export const extract_dictionaries = (source) => {
  const acc = { locations: {}, carriers: {} };
  if (!source || typeof source !== 'object') return acc;
  KNOWN_FLIGHT_SOLUTIONS_PATHS.forEach((path) => {
    fold_solutions_segments(acc, get_object_field(source, path, null));
  });
  KNOWN_DICT_PATHS.forEach((path) => {
    fold_canonical_block(acc, get_object_field(source, path, null));
  });
  return acc;
};
